









import Vue from 'vue';
import { logout } from '../repository';

export default Vue.extend({
  name: 'Logout',
  async mounted () {
    await logout();
    this.$router.push({ name: 'Login', params: { returnUrl: '/spotv2/' } });
  }
});
